import { configureStore } from '@reduxjs/toolkit';
import artReducer from '../features/art/artSlice';

export default configureStore({
  reducer: {
    art: artReducer,
  },
});
